import styled from 'styled-components';
import { colors } from 'pages/Quotes/styles/colors';

export const Container: any = styled.div`
  width: 144px;
   .select-first, [class*="control"], [class*="ValueContainer"] {
    font-size: 16px !important;
    font-family: "Lato", sans-serif !important;
    align-content: center;
    height: 32px;
   }

  [class*="Input"] {
    height: 32px;
    font-size: 16px !important;
    font-family: "Lato", sans-serif !important;
  }

  div[class*="option"] {
    display: grid;
    color: #3a3a3a;
    height: 32px;
    align-content: center;
    &:hover {
      background-color: #0e4c54;
      color: #fff;
    }
  }
  
  [class*="control"]{
    height: 32px !important;
  }

  div[class*="menu"] {
    z-index: 2;
  }

  input {
    height: 32px;
    width: 100% !important;
    font-size: 12px !important;
  }

  /**
  * Separator
  */
  [class*="indicatorSeparator"] {
    display: none;
  }

  /**
  * Multi
  */
  [class*="multiValue"] {
    color: #f2f2f2;
    background: ${colors["dg-orange"]};

    div {
      color: #f2f2f2;
      font-weight: bold;
    }
  }

  [class*="control"] {
    box-shadow: none !important;
    ${(props: any) => !props.disabled && !props.error ? `
    border: 1px solid #BCBCBC;
    &:hover {
      border: 1px solid #0e4c54;
    }
    ` : props.error ? `
    border: 1px solid ${colors.danger};
    &:hover {
      border: 1px solid ${colors.danger};
    }
    ` : undefined};
  }

  .css-yk16xz-control, .css-yk16xz-control:hover {
    box-shadow: none !important;

    ${(props: any) => props.error ? `
    border: 1px solid ${colors.danger};
    ` : `
    border: 1px solid #F0F0F0;
    `
  }
  }

  [class*="ValueContainer"] {
    ${(props: any) => !props.isMulti && `
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      align-content: center;
    `}
  }

  [class*="placeholder"] {
    align-self: center;
    color: #364863;
  }

  [class*="indicatorContainer"] {
    cursor: pointer;
  }

  [class*="Input"] {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    display:flex;
    align-items: center;
    height: 32px;
  }
`;
